import React, { useEffect, useRef, useState } from "react";
import "./LandingPage.css";

const LandingPage = ({ welcomeContent }) => {
  const urlPath = window.location.href;
  const contentAsObject =
    welcomeContent &&
    welcomeContent?.reduce(
      (obj, item) =>
        Object.assign(obj, { [item.Variable_Name]: item.translated_text }),
      {}
    );

  const [openTruckGuides, setOpenTruckGuides] = useState(false);
  const [openEmergencyPortal, setOpenEmergencyPortal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const truckTooltipRef = useRef(null);
  const emergencyTooltipRef = useRef(null);

  const handleTooltipCloseTruckGuides = () => {
    setOpenTruckGuides(false);
  };

  const handleTooltipToggleTruckGuides = () => {
    setOpenTruckGuides((prevOpenTruckGuides) => !prevOpenTruckGuides);
  };

  const handleTooltipCloseEmergencyPortal = () => {
    setOpenEmergencyPortal(false);
  };

  const handleTooltipToggleEmergencyPortal = () => {
    setOpenEmergencyPortal((prevOpenEmergencyPortal) => !prevOpenEmergencyPortal);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        truckTooltipRef.current &&
        !truckTooltipRef.current.contains(event.target)
      ) {
        handleTooltipCloseTruckGuides();
      }

      if (
        emergencyTooltipRef.current &&
        !emergencyTooltipRef.current.contains(event.target)
      ) {
        handleTooltipCloseEmergencyPortal();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, []);

  const ownersTitle =
    (contentAsObject?.$$welcome_text || "") +
    " " +
    (contentAsObject?.$$ownersManual_welcome_description || "");

  const emergencyTitle =
    (contentAsObject?.$$welcome_text || "") +
    " " +
    (contentAsObject?.$$emergencyPortal_welcome_description || "");

  const openOwnersManual = () => {
    window.open(
      `${urlPath}truckownermanuals/`,
      "_blank"
    );
  };

  const openEmergency = () => {
    window.open(
      `${urlPath}emergencyportal/`,
      "_blank"
    );
  };

  return (
    <div className="landing-page-container">
      <div className="landing-page-grid">
        <div className="tile">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/TileImage2.png"}
            className="image-card"
            alt="Truck Owners Manual"
            onClick={openOwnersManual}
          />

          <div className="tile-info-row">
            <p className="tile-text">Truck Owners Manual</p>
            <div
              ref={truckTooltipRef}
              className="tooltip-wrapper"
              onMouseEnter={!isMobile ? () => setOpenTruckGuides(true) : undefined}
              onMouseLeave={!isMobile ? () => setOpenTruckGuides(false) : undefined}
            >
              <img
                className="logo-img tooltip tooltip-icon"
                src={process.env.PUBLIC_URL + "/assets/images/QuestionmarkIcon.svg"}
                alt="Truck Owners Manual info"
                onClick={isMobile ? handleTooltipToggleTruckGuides : undefined}
              />
              {openTruckGuides && (
                <div className="simple-tooltip">{ownersTitle.trim()}</div>
              )}
            </div>
          </div>
        </div>

        <div className="tile">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/TileImage1.png"}
            className="image-card"
            alt="Emergency Portal"
            onClick={openEmergency}
          />
          <div className="tile-info-row">
            <p className="tile-text">Emergency Portal</p>
            <div
              ref={emergencyTooltipRef}
              className="tooltip-wrapper"
              onMouseEnter={!isMobile ? () => setOpenEmergencyPortal(true) : undefined}
              onMouseLeave={!isMobile ? () => setOpenEmergencyPortal(false) : undefined}
            >
              <img
                className="logo-img tooltip tooltip-icon"
                src={process.env.PUBLIC_URL + "/assets/images/QuestionmarkIcon.svg"}
                alt="Emergency Portal info"
                onClick={isMobile ? handleTooltipToggleEmergencyPortal : undefined}
              />
              {openEmergencyPortal && (
                <div className="simple-tooltip2">{emergencyTitle.trim()}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
